import { render, staticRenderFns } from "./approved-ledgers-list.vue?vue&type=template&id=042816e8&scoped=true"
import script from "./approved-ledgers-list.vue?vue&type=script&lang=ts"
export * from "./approved-ledgers-list.vue?vue&type=script&lang=ts"
import style0 from "./approved-ledgers-list.vue?vue&type=style&index=0&id=042816e8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042816e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('042816e8')) {
      api.createRecord('042816e8', component.options)
    } else {
      api.reload('042816e8', component.options)
    }
    module.hot.accept("./approved-ledgers-list.vue?vue&type=template&id=042816e8&scoped=true", function () {
      api.rerender('042816e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ledgers/approved-ledgers-list.vue"
export default component.exports